/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CommunicationTrackingEventType {
  EMAIL_PROCESSED = 'email_processed',
  EMAIL_DELIVERED = 'email_delivered',
  EMAIL_DEFERRED = 'email_deferred',
  EMAIL_BOUNCE = 'email_bounce',
  EMAIL_DROPPED = 'email_dropped',
  EMAIL_OPEN = 'email_open',
  EMAIL_CLICK = 'email_click',
  EMAIL_SPAM_REPORT = 'email_spam_report',
  EMAIL_UNSUBSCRIBE = 'email_unsubscribe',
  EMAIL_GROUP_UNSUBSCRIBE = 'email_group_unsubscribe',
  EMAIL_GROUP_RESUBSCRIBE = 'email_group_resubscribe',
  SMS_DISPATCHED = 'sms_dispatched',
  SMS_QUEUED = 'sms_queued',
  SMS_SENT = 'sms_sent',
  SMS_DELIVERED = 'sms_delivered',
  SMS_FAILED = 'sms_failed',
  SMS_UNDELIVERED = 'sms_undelivered',
  SMS_WRONG_NUMBER = 'sms_wrong_number',
  SMS_GENERIC_ERROR = 'sms_generic_error',
}
